import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchFeed } from '../redux/feedInfiniteSlice'
import { deleteDraft } from '../redux/apis'

import Detail from '../components/DesignerCommon/Detail'
import Feed from '../components/DesignerFeed/Feed'
import DesignFeedContainer from '../components/DesignerDesigns/DesignFeedContainer'
import DesignDraftCard from '../components/DesignerDesigns/cards/DesignDraftCard'
import DesignFeedCard from '../components/DesignerDesigns/cards/DesignFeedCard'
import DeleteConfirmation from '../components/DesignerModals/DeleteConfirmation'
import DesignAddCard from '../components/DesignerDesigns/cards/DesignAddCard'

import { FEED_RESET } from '../redux/constants'
import { logEvent } from '../utils/firebase'
import { useRouter as useHistory } from 'next/router'

const Card = props => {
  return (
    <DesignFeedCard sizeless={false}>
      <DesignDraftCard mobileGrid {...props}></DesignDraftCard>
    </DesignFeedCard>
  )
}

const AddCard = props => {
  const history = useHistory()

  const handleClick = e => {
    history.push(`/templates`)
  }

  return (
    <DesignFeedCard>
      <DesignAddCard
        title="Create Design"
        onClick={handleClick}
      ></DesignAddCard>
    </DesignFeedCard>
  )
}

const Drafts = props => {
  const dispatch = useDispatch()
  const {
    feed: drafts,
    loading,
    error,
    end
  } = useSelector(state => state.draft)
  //const rDeleteConfirmation = useRef()
  const [toDelete, setToDelete] = useState()
  const [show, setShow] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(fetchFeed('draft')({ status: FEED_RESET }))
  }, [dispatch])

  const handleModalClose = () => {
    //rDeleteConfirmation.current.hide()
    setShow(false)
  }

  const handleDeleteToConfirm = data => {
    setShow(true)
    //rDeleteConfirmation.current.show()
    setToDelete(data)
  }

  const handleDelete = () => {
    if (!toDelete) return

    logEvent('draft_delete', {
      content_type: 'draft',
      content_id: toDelete.objectId
    })

    if (!toDelete.objectId) return

    deleteDraft(toDelete.objectId).then(() => {
      dispatch(fetchFeed('draft')({ status: FEED_RESET }))
      //rDeleteConfirmation.current.hide()
      setShow(false)
    })
  }

  const handleFetchDrafts = () => {
    dispatch(fetchFeed('draft')({ status: null }))
  }

  return (
    <>
      <DeleteConfirmation
        show={show}
        title={'Delete your draft?'}
        onClose={handleModalClose}
        onDelete={handleDelete}
      >
        Are you sure you want to delete you draft?
      </DeleteConfirmation>
      <Detail title="Draft" backToRoot>
        <DesignFeedContainer>
          <AddCard />
          <Feed
            data={drafts}
            onFetch={handleFetchDrafts}
            onDelete={handleDeleteToConfirm}
            card={Card}
            loading={loading}
            error={error}
            from="/drafts"
            end={end}
          />
        </DesignFeedContainer>
      </Detail>
    </>
  )
}

export default Drafts
